import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=ae9af45a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=ae9af45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9af45a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae9af45a')) {
      api.createRecord('ae9af45a', component.options)
    } else {
      api.reload('ae9af45a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=ae9af45a&scoped=true&", function () {
      api.rerender('ae9af45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zpk3kgy1cvL6/JS/comp/CookieBox.vue"
export default component.exports